'use strict';

var makeNonNullableArray = require('./makeNonNullableArray.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Merges two sets of component props into a single set of props.
 *
 * @template T - The type of the component props.
 * @param currentProps - The current set of component props.
 * @param newProps - The new set of component props.
 * @returns The merged set of component props.
 */ function mergeProps(currentProps, newProps) {
    const { className = '', style = {} } = currentProps, currentRest = _object_without_properties_loose(currentProps, [
        "className",
        "style"
    ]);
    const { className: newClassName = '', style: newStyle = {} } = newProps, newRest = _object_without_properties_loose(newProps, [
        "className",
        "style"
    ]);
    return _extends({}, currentRest, newRest, {
        className: makeNonNullableArray([
            className,
            newClassName
        ]).join(' '),
        style: _extends({}, style, newStyle)
    });
}

module.exports = mergeProps;
